import { Routes, Route, useLocation } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Enterprise from "@/pages/Enterprise";
import Press from "@/pages/Press";
import ProductPage from "@/pages/ProductPage";
import AppLegalPage from "@/pages/AppLegalPage";
import SimplePage from "@/pages/SimplePage";
import NotFound from "@/pages/NotFound";
import Studio from "@/pages/Studio";
import DeviceStudio from "@/pages/DeviceStudio";

const PAGE_ROUTES = [
  { path: "/", element: <Home /> },
  { path: "/enterprise", element: <Enterprise /> },
  { path: "/press", element: <Press /> },
  { path: "/app/:slug", element: <ProductPage /> },
  { path: "/app/:slug/privacy", element: <AppLegalPage kind="privacy" /> },
  { path: "/app/:slug/terms", element: <AppLegalPage kind="terms" /> },
  { path: "/about", element: <SimplePage page="about" /> },
  { path: "/privacy", element: <SimplePage page="privacy" /> },
  { path: "/terms", element: <SimplePage page="terms" /> },
  { path: "/studio", element: <Studio /> },
  { path: "/devicestudio", element: <DeviceStudio /> },
];

export default function Layout() {
  const { pathname } = useLocation();
  const isBare = pathname.startsWith("/studio") || pathname.startsWith("/devicestudio");
  return (
    <div className="App min-h-screen bg-paper font-sans text-ink antialiased">
      {!isBare && (
        <a
          href="#main-content"
          data-testid="skip-to-content"
          className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[100] focus:rounded-full focus:bg-ink focus:px-5 focus:py-2.5 focus:text-sm focus:font-semibold focus:text-paper"
        >
          Skip to content
        </a>
      )}
      {!isBare && <Header />}
      <main id="main-content">
        <Routes>
          {PAGE_ROUTES.flatMap((r) => [
            <Route key={r.path} path={r.path} element={r.element} />,
            <Route
              key={`es${r.path}`}
              path={r.path === "/" ? "/es" : `/es${r.path}`}
              element={r.element}
            />,
          ])}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      {!isBare && <Footer />}
    </div>
  );
}
